import script from "./WarehousesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehousesTable.vue?vue&type=script&setup=true&lang=js"

import "./WarehousesTable.vue?vue&type=style&index=0&id=332c3da8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332c3da8"]])

export default __exports__